/*
 * Vagt for pakkernes gavevarer.
 *
 * Gaverne er rigtige varer til 0 kr, fordi en rabat ville slukke MyCosmo-koden.
 * Se docs/webshop-pakker.md. Prisen for det valg er at gaven skal bevogtes:
 * en 0-kr vare i kurven uden sin pakke er en gave foraeret vaek.
 *
 * FOERSTE UDGAVE VAR FOR SVAG, og det blev fanget i test 3. september 2026.
 * Den var skrevet i Liquid og blev derfor kun beregnet ved en HEL
 * sideindlaesning. Kurven opdateres med AJAX: sletter kunden en vare paa
 * /cart, skiftes kun sektionens markup ud, siden genindlaeses ikke, og vagten
 * kom aldrig til. Man kunne altsaa laegge en pakke i kurven, slette en af de
 * tre varer, og gaa til betaling med gaven i behold.
 *
 * Derfor koerer den nu i browseren og tjekker:
 *   - ved sideindlaesning
 *   - efter ENHVER aendring af kurven, uanset hvem der lavede den
 *   - og den spaerrer for betaling hvis kurven kendes som ugyldig
 *
 * Gaver kendes paa `product_type === 'Gave'`, som foelger med i /cart.js.
 * Tags goer ikke, og handles er skoerere: produkttypen saettes af
 * scripts/opret_pakkekampagne.py og er den samme for alle gaver, ogsaa i en
 * senere kampagne.
 *
 * Tilbage staar ét hul, som en vagt i browseren ikke kan lukke: et
 * kurv-permalink springer direkte til Shopifys checkout, som ikke renderes af
 * temaet. Det kraever en Shopify Function. Se docs/webshop-pakker.md.
 */
(function () {
  var GAVE_TYPE = 'Gave';
  var KRAEVEDE_LEDSAGERE = 3;

  // Kendes kurven som ugyldig, spaerres betalingsknappen. Vaerdien saettes af
  // hvert tjek, saa klik-haandteringen kan traeffe sin beslutning SYNKRONT.
  // Et asynkront tjek i klikket ville kraeve at vi afspillede klikket igen
  // bagefter, og saa ville PostHog taelle begin_checkout to gange.
  var kurvenErOk = true;
  var koerer = false;
  var venter = null;

  function erGave(linje) {
    return linje.product_type === GAVE_TYPE;
  }

  function pakkenavn(linje) {
    return (linje.properties && linje.properties.Pakke) || '';
  }

  /*
   * Finder de gavelinjer der ikke hoerer til en hel pakke.
   * Tre betingelser, alle skal vaere opfyldt:
   *   1. Gaven skal baere egenskaben "Pakke". Et permalink kan ikke saette
   *      linjeegenskaber, saa en gave lagt ind ad bagvejen falder allerede her
   *   2. Der skal ligge mindst tre ikke-gave-linjer med samme pakkenavn
   *   3. Gaven maa hoejst ligge i ét eksemplar
   */
  function findAendringer(kurv) {
    var aendringer = [];
    var gaver = kurv.items.filter(erGave);
    if (!gaver.length) return aendringer;

    gaver.forEach(function (gave) {
      var navn = pakkenavn(gave);
      var ledsagere = 0;

      if (navn) {
        ledsagere = kurv.items
          .filter(function (i) {
            return !erGave(i) && pakkenavn(i) === navn;
          })
          .reduce(function (sum, i) {
            return sum + i.quantity;
          }, 0);
      }

      if (ledsagere < KRAEVEDE_LEDSAGERE) {
        aendringer.push({ id: gave.key, quantity: 0 });
      } else if (gave.quantity > 1) {
        aendringer.push({ id: gave.key, quantity: 1 });
      }
    });

    return aendringer;
  }

  function hentKurv() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function anvend(aendring) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(aendring),
    });
  }

  function tjek() {
    if (koerer) return Promise.resolve(false);
    koerer = true;

    return hentKurv()
      .then(function (kurv) {
        var aendringer = findAendringer(kurv);
        if (!aendringer.length) {
          kurvenErOk = true;
          return false;
        }

        kurvenErOk = false;

        // Én ad gangen. Parallelle kald mod /cart/change kan overskrive
        // hinanden, fordi hvert svar er hele kurvens nye tilstand.
        return aendringer
          .reduce(function (kaede, aendring) {
            return kaede.then(function () {
              return anvend(aendring);
            });
          }, Promise.resolve())
          .then(function () {
            kurvenErOk = true;
            return true;
          });
      })
      .catch(function (e) {
        console.error('pakke-vagt:', e);
        return false;
      })
      .finally(function () {
        koerer = false;
      });
  }

  function tjekOgOpdater() {
    return tjek().then(function (aendret) {
      // Blev der rettet noget, skal siden vise det. Paa kurven er den viste
      // markup nu forkert; andre steder er der kun kurv-taelleren at rette,
      // og den ordner naeste sidevisning.
      if (aendret && /\/cart(\/|$|\?)/.test(window.location.pathname + window.location.search)) {
        window.location.reload();
      }
      return aendret;
    });
  }

  function tjekSnart() {
    clearTimeout(venter);
    venter = setTimeout(tjekOgOpdater, 250);
  }

  /*
   * Enhver aendring af kurven skal udloese et tjek, uanset hvem der lavede den:
   * temaets egen kurv-kode, en app, eller vores egen pakkeknap. Derfor lyttes
   * der paa netvaerkslaget frem for paa temaets events. Samme greb som
   * posthog-tracking bruger til add_to_cart.
   */
  var oprindeligFetch = window.fetch;
  window.fetch = function () {
    var svar = oprindeligFetch.apply(this, arguments);
    try {
      var url = arguments[0];
      var sti = typeof url === 'string' ? url : url && url.url;
      if (sti && /\/cart\/(add|change|update|clear)/.test(sti)) {
        svar.then(function () {
          tjekSnart();
        });
      }
    } catch (e) {
      /* Sporing af kurv-kald maa aldrig staa i vejen for kurv-kaldet selv. */
    }
    return svar;
  };

  var oprindeligSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    try {
      var xhr = this;
      xhr.addEventListener('load', function () {
        if (xhr.__pakkeSti && /\/cart\/(add|change|update|clear)/.test(xhr.__pakkeSti)) tjekSnart();
      });
    } catch (e) {
      /* ignoreres */
    }
    return oprindeligSend.apply(this, arguments);
  };

  var oprindeligOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (metode, sti) {
    this.__pakkeSti = sti;
    return oprindeligOpen.apply(this, arguments);
  };

  /*
   * Sidste vaern: kendes kurven som ugyldig, maa man ikke naa checkout.
   * Beslutningen er synkron, saa klikket bare stoppes og siden genindlaeses.
   * Efter genindlaesningen har vagten ryddet op, og kunden kan gaa videre.
   */
  document.addEventListener(
    'click',
    function (e) {
      if (kurvenErOk) return;
      var knap = e.target.closest('[name="checkout"], a[href*="/checkout"], .cart__checkout-button');
      if (!knap) return;
      e.preventDefault();
      e.stopPropagation();
      window.location.reload();
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tjekOgOpdater);
  } else {
    tjekOgOpdater();
  }
})();
